export default "__VITE_ASSET__BsEjS6zn__"